// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfigManager_container__5LeWh","tableContainer":"ConfigManager_tableContainer__xxLUS"};